import SoloFind from './SoloFind';
export default SoloFind;
